import type { ReactNode } from 'react';

import { useTranslation } from 'react-i18next';

import { getTestProps } from '../../../lib/helpers';

import { MenuIcon } from '../../../images/shapes';

import Button from '../../Button/Button';
import { PopoverPanelPlacement } from '../../Popover/classes';
import PopoverComponent from '../../Popover/Popover';

interface StatusbarActionMenuProps {
  /**
   * Statusbar action menu items
   */
  children?: ReactNode;
  /**
   * test id
   */
  testId?: string;
}

const StatusbarActionMenu = ({
  children,
  testId,
}: StatusbarActionMenuProps) => {
  const { t } = useTranslation();

  return (
    <PopoverComponent
      popoverPanelPlacement={PopoverPanelPlacement.TopLeft}
      popoverPhonePanelPlacement={PopoverPanelPlacement.TopLeft}
      additionalPopoverPanelClasses="border-blue dark:border-blue "
      additionalClasses="z-0"
      {...getTestProps(testId, 'action-menu', 'testId')}
      popoverButton={
        <Button
          iconImage={<MenuIcon className="w-4 min-w-4" />}
          iconPosition="start"
          as="span"
          additionalChildrenClasses="hidden xs:inline"
          additionalIconClasses="m-0 xs:mr-2"
          buttonColor="blueBordered"
        >
          {t('ObjectsOfType.Actions')}
        </Button>
      }
      content={children}
    />
  );
};

export default StatusbarActionMenu;
